import { render, staticRenderFns } from "./CalendarioEscolar.vue?vue&type=template&id=4dc8e681&"
import script from "./CalendarioEscolar.vue?vue&type=script&lang=js&"
export * from "./CalendarioEscolar.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioEscolar.vue?vue&type=style&index=0&id=4dc8e681&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports